import {
  ACTION_MASTERDATA_START,
  ACTION_MASTERDATA_END,
  STORE_LOCATIONS,
  STORE_CITY,
  STORE_REGION,
  SEARCH_STORES,
  SAVED_STORES,
  STORE_STATE,
  STORE_ZONE,
  STORE_PINCODE,
  STORE_PARENT_ZONE,
  UPDATE_STORES,
  GET_LOCATION_COUNT,
  GET_CITY_COUNT,
  GET_STATE_COUNT,
  GET_ZONE_COUNT,
  GET_SERVICE_NAME,
  GET_SERVICE_PRICE,
  SAVE_SERVICE_PRICE,
  UPDATE_SERVICE_PRICE,
  GET_LOCATION_DATA,
  SAVED_FILES,
  SAVED_ZONE,
  C2C_ZONE,
  GET_ZONE_DATA,
  LOCATION_BASED_ZONE,
  GET_PINCODE_COUNT,
  GET_INTERCITY_COUNT,
  FETCHED_INTERCITY_ROUTE_LIST,
  FETCHING_INTERCITY_ROUTE_LIST,
  STORE_INTERCITY,
  GET_DRIVER_COUNT,
  SEARCH_DRIVERS,
  SAVED_DRIVER,
  UPDATE_DRIVER,
  GET_MAKE_LIST,
  SEARCH_MAKE_LIST,
} from '../actions/masterData/masterData.actiontype';

const initialState = {
  isFetchingList: false,
  isProcessing: false,
  storeLocations: [],
  storeCities: [],
  stores: [],
  storeRegions: [],
  locationCount: 0,
  cityCount: 0,
  stateCount: 0,
  zoneCount: 0,
  pincodeCount: 0,
  intercityCount: 0,
  storeIntercity: [],
  message: '',
  savedFile: '',
  savedZone: '',
  c2cZone: [],
  zoneCodeLocation: [],
};

const MasterData = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_MASTERDATA_START:
      return {
        ...state,
        isProcessing: true,
      };

    case ACTION_MASTERDATA_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }

    case STORE_LOCATIONS: {
      let allStores = filterStores(action.payload);
      return {
        ...state,
        storeLocations: allStores,
        isProcessing: false,
      };
    }

    case SAVED_ZONE: {
      return {
        ...state,
        savedZone: action.payload,
        isProcessing: false,
      };
    }

    case LOCATION_BASED_ZONE: {
      return {
        ...state,
        zoneCodeLocation: action.payload,
        isProcessing: false,
      };
    }

    case SAVED_FILES: {
      return {
        ...state,
        savedFile: action.payload,
        isProcessing: false,
      };
    }

    case STORE_STATE: {
      return {
        ...state,
        storeState: action.payload,
        isProcessing: false,
      };
    }

    case GET_MAKE_LIST: {
      return {
        ...state,
        makeList: action.payload,
        isProcessing: false,
      };
    }

    case SEARCH_MAKE_LIST: {
      return {
        ...state,
        searchMakeList: action.payload,
        isProcessing: false,
      };
    }

    case STORE_CITY: {
      return {
        ...state,
        storeCities: action.payload,
        isProcessing: false,
      };
    }

    case STORE_REGION: {
      return {
        ...state,
        storeRegions: action.payload,
        isProcessing: false,
      };
    }

    case STORE_ZONE: {
      return {
        ...state,
        storeZone: action.payload,
        isProcessing: false,
      };
    }

    case STORE_PINCODE: {
      return {
        ...state,
        storePincode: action.payload,
        isProcessing: false,
      };
    }

    case GET_ZONE_DATA: {
      return {
        ...state,
        zoneData: action.payload,
        isProcessing: false,
      };
    }

    case C2C_ZONE: {
      return {
        ...state,
        c2cZone: action.payload,
        isProcessing: false,
      };
    }

    case STORE_PARENT_ZONE: {
      return {
        ...state,
        parentZones: action.payload,
        isProcessing: false,
      };
    }

    case SEARCH_STORES: {
      let allStores = filterStores(action.payload);
      return {
        ...state,
        stores: allStores,
        isProcessing: false,
      };
    }

    case SAVED_STORES: {
      return {
        ...state,
        saveStores: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_STORES: {
      return {
        ...state,
        saveStores: action.payload,
        isProcessing: false,
      };
    }

    case GET_CITY_COUNT: {
      return {
        ...state,
        cityCount: action.payload,
      };
    }

    case GET_STATE_COUNT: {
      return {
        ...state,
        stateCount: action.payload,
      };
    }

    case GET_ZONE_COUNT: {
      return {
        ...state,
        zoneCount: action.payload,
      };
    }

    case GET_PINCODE_COUNT: {
      return {
        ...state,
        pincodeCount: action.payload,
      };
    }

    case GET_LOCATION_COUNT: {
      return {
        ...state,
        locationCount: action.payload,
      };
    }

    case GET_DRIVER_COUNT: {
      return {
        ...state,
        driverCount: action.payload,
      };
    }

    case SEARCH_DRIVERS: {
      return {
        ...state,
        drivers: action.payload,
        isProcessing: false,
      };
    }

    case SAVED_DRIVER: {
      return {
        ...state,
        saveDriver: action.payload,
        driverSaved: true,
        isProcessing: false,
      };
    }

    case UPDATE_DRIVER: {
      return {
        ...state,
        driverSaved: true,
        saveDriver: action.payload,
        isProcessing: false,
      };
    }

    case GET_SERVICE_NAME: {
      return {
        ...state,
        serviceName: action.payload,
      };
    }

    case GET_SERVICE_PRICE: {
      return {
        ...state,
        servicePrice: action.payload,
      };
    }

    case SAVE_SERVICE_PRICE: {
      return {
        ...state,
        savedServicePrice: action.payload,
        locationData: action.payload,
        isProcessing: false,
      };
    }

    case UPDATE_SERVICE_PRICE: {
      return {
        ...state,
        updatedServicePrice: action.payload,
        isProcessing: false,
      };
    }

    case GET_LOCATION_DATA: {
      return {
        ...state,
        locationData: action.payload,
      };
    }

    case FETCHED_INTERCITY_ROUTE_LIST: {
      return {
        ...state,
        isFetchingList: false,
      };
    }

    case FETCHING_INTERCITY_ROUTE_LIST: {
      return {
        ...state,
        isFetchingList: true,
      };
    }

    case STORE_INTERCITY: {
      return {
        ...state,
        storeIntercity: action.payload,
        isFetchingList: false,
        isProcessing: false,
      };
    }

    case GET_INTERCITY_COUNT: {
      return {
        ...state,
        intercityCount: action.payload,
      };
    }

    default:
      return state;
  }
};

function filterStores(stores) {
  let filteredStores = [];
  stores.forEach((element) => {
    if (element.code) {
      filteredStores.push(element);
    }
  });

  return filteredStores;
}

export default MasterData;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
